import { cfgCdnBase, cfgToThemeCdnPath } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
export const bigCardPublic = {
    title: Verbiage.welcome_bonus,
    description: Verbiage.up_to_x_bonus_on_your_first_x_deposits,
    backgroundImage: cfgToThemeCdnPath('/top-section/big-card-public.png'),
    backgroundImageMobile: cfgToThemeCdnPath('/top-section/big-card-public-mobile.png'),
    bonus_amount: '$3,000',
    number_of_deposits: 3
};
export const smallCards = [
    {
        title: Verbiage.casino,
        description: Verbiage.only_the_games_you_want_to_play,
        backgroundImage: cfgToThemeCdnPath('/top-section/small-card-1.png'),
        backgroundImageMobile: cfgToThemeCdnPath('/top-section/small-card-1-mobile.png'),
        linkUrl: '/casino',
        badgeText: Verbiage.go_to_slots,
        badgeGradient: 'linear-gradient(270deg, var(--color-error-300) 0%, var(--color-error-500) 100%)',
        position: 'left'
    },
    {
        title: Verbiage.sports,
        description: Verbiage.global_sports_premium_odds,
        backgroundImage: cfgToThemeCdnPath('/top-section/small-card-2.png'),
        backgroundImageMobile: cfgToThemeCdnPath('/top-section/small-card-2-mobile.png'),
        linkUrl: '/sports',
        badgeText: Verbiage.go_to_sports,
        badgeGradient: 'linear-gradient(90deg, var(--color-success-300) 0%, var(--color-success-500) 100%)',
        position: 'right'
    },
    {
        title: Verbiage.vip_galaxy,
        description: Verbiage.all_bets_fuels_your_rewards,
        backgroundImage: cfgToThemeCdnPath('/top-section/small-card-3.png'),
        backgroundImageMobile: cfgToThemeCdnPath('/top-section/small-card-3-mobile.png'),
        linkUrl: '/vip',
        badgeText: Verbiage.go_to_vip,
        badgeGradient: 'linear-gradient(90deg, var(--color-text-100) 0%, var(--color-text-300) 100%)',
        position: 'left'
    },
    {
        title: Verbiage.rocket_races,
        description: Verbiage.turn_every_spin_into_cash_prizes,
        backgroundImage: cfgToThemeCdnPath('/top-section/small-card-4.png'),
        backgroundImageMobile: cfgToThemeCdnPath('/top-section/small-card-4-mobile.png'),
        linkUrl: '/tournaments/#/tournaments/',
        badgeText: Verbiage.go_to_races,
        badgeGradient: 'linear-gradient(90deg, var(--color-warning-300) 0%, var(--color-warning-500) 100%)',
        position: 'right'
    }
];
